import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface UserGroupDialogStore {
  showUserGroupDialog: boolean;
  /** Selection happens while a booking draft is in flight (login mid-flow) — the draft must survive it. */
  keepBookingDrafts: boolean;
  openUserGroupDialog: (options?: { keepBookingDrafts?: boolean }) => void;
  closeUserGroupDialog: () => void;
}

const initialStateUserGroupDialogStore = {
  showUserGroupDialog: false,
  keepBookingDrafts: false
};

export const useUserGroupDialogStore = create<UserGroupDialogStore>()(
  persist(
    (set) => ({
      ...initialStateUserGroupDialogStore,
      openUserGroupDialog: (options) =>
        set({
          showUserGroupDialog: true,
          keepBookingDrafts: options?.keepBookingDrafts ?? false
        }),
      closeUserGroupDialog: () => set(initialStateUserGroupDialogStore)
    }),
    {
      name: 'userGroupDialogStore',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

// Getters
export const useShowUserGroupDialog = () => useUserGroupDialogStore((state) => state.showUserGroupDialog);
export const useKeepBookingDrafts = () => useUserGroupDialogStore((state) => state.keepBookingDrafts);

// Actions
export const useUserGroupDialogActions = () => {
  const openUserGroupDialog = useUserGroupDialogStore((state) => state.openUserGroupDialog);
  const closeUserGroupDialog = useUserGroupDialogStore((state) => state.closeUserGroupDialog);
  return {
    openUserGroupDialog,
    closeUserGroupDialog
  };
};
